module.exports = __webpack_public_path__ + "img/product-three-0.28f0f1f1.png";